import { Box } from '@mui/material';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
import { useEffect, useMemo, useState } from 'react';
import { getJobById, getTotalAISuggestionMappedCandidatesByRecruiters } from 'wisestep-api';
import { WsTypography, WsColors } from 'wisestep-base';

import { IAggregation } from '../../types';

import IPayloadDTOJobsCrm from './types/IPayloadDTOJobsCrm';

const JobCrmAiSuggestionMappedCandidatesByRecruiters = ({ payload }: IPayloadDTOJobsCrm) => {
  const paginationSize = 5;
  const [aggregatedData, setAggregatedData] = useState<IAggregation[]>([]);
  useEffect(() => {
    const fetchData = async () => {
      const jobDetails = await getJobById(payload.jobId ?? '');
      payload.jobCode = jobDetails?.data?.jobCode;
      const response = await getTotalAISuggestionMappedCandidatesByRecruiters(payload);
      setAggregatedData(response.data.aggregations.aggregation.buckets);
    };
    fetchData();
  }, [payload]);

  const tableData = useMemo(() => {
    const rows: Record<string, unknown>[] = [];
    aggregatedData?.map((item) => {
      rows.push({
        id: item.key,
        cvViewCount: item.aggregation?.buckets?.length ?? 0,
      });
    });

    return { rows };
  }, [aggregatedData]);

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: `Recruiter Name`,
      flex: 2,
    },
    {
      field: 'cvViewCount',
      headerName: `CV Mapped Count`,
      flex: 1,
    },
  ];

  return (
    <Box>
      <WsTypography bold={true}>AI Suggestion Mapped Per Recruiter</WsTypography>
      <Box style={{ height: 670, background: WsColors.White }} mt={1.5}>
        <DataGrid
          columns={columns}
          rows={tableData.rows}
          components={{ Toolbar: GridToolbar }}
          pageSize={paginationSize}
          rowsPerPageOptions={[paginationSize]}
        />
      </Box>
    </Box>
  );
};

export default JobCrmAiSuggestionMappedCandidatesByRecruiters;
